import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'ftr-stack',
  templateUrl: './stack.component.html',
  styleUrls: ['./stack.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class StackComponent {
  @Input() size: 'zero' | 'xsmall' | 'small' | 'medium' | 'large' = 'medium'
}
